import { selectFromConfig } from '@gandi/redux-config';
import { selectOneOrganization, selectCurrent } from '@gandi/redux-sharing';
import { selectCartIsActive, selectCartOwner, selectNonBundledProducts, selectCartBundles } from '../../../modules/selectors';
export const selectShopURL = selectFromConfig('app.layout.urls.shop', 'https://shop.gandi.net');
export const selectAppName = selectFromConfig('app.name', 'dashboard');
export const selectCartOwnerOrganization = state => {
  if (!selectCartIsActive(state)) {
    return undefined;
  }
  const cartOwner = selectCartOwner(state);
  if (cartOwner) {
    return selectOneOrganization(state, {
      id: cartOwner
    });
  }
  return selectCurrent(state);
};
export const selectCountItems = state => selectNonBundledProducts(state).length + selectCartBundles(state).length;
export const selectCountItemsPessimistic = state => selectNonBundledProducts(state).filter(({
  status
}) => status !== 'optimistic').length + selectCartBundles(state).length;